var _g, _rect, _path, _rect2, _rect3, _path2, _circle, _rect4, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCvvAmex = function SvgCvvAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 54,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cvvAmex_svg__filter0_dd_1909_22582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 65.641,
    height: 41.29,
    rx: 6,
    fill: "#F3F4F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.823,
    y: 7.823,
    width: 59.994,
    height: 35.379,
    rx: 5,
    stroke: "#CED4D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.02 20h.426v-3.545h-.325c-.085.455-.41.665-1.005.665H52.1v.34h.92V20zm1.579 0h2.315v-.375h-1.82c.05-.275.235-.495.78-.81.445-.255.735-.48.87-.68.135-.195.205-.415.205-.66 0-.625-.455-1.02-1.11-1.02-.695 0-1.145.465-1.145 1.165l.005.09h.425v-.035c0-.485.255-.845.69-.845.385 0 .685.27.685.645 0 .2-.055.37-.17.515-.11.14-.375.345-.785.59-.345.205-.59.425-.72.645-.13.22-.2.48-.225.775zm3.953.06c.71 0 1.215-.42 1.215-1.08 0-.45-.22-.765-.64-.86v-.01c.32-.155.49-.42.49-.71 0-.585-.4-.945-1.075-.945-.665 0-1.065.41-1.1 1.145h.425c.01-.485.26-.77.675-.77.375 0 .63.215.63.57 0 .34-.285.58-.705.58-.07 0-.12 0-.16-.005v.36c.085-.01.17-.015.24-.015.47 0 .77.26.77.68 0 .4-.33.685-.765.685-.45 0-.735-.275-.755-.78h-.43v.015c0 .735.48 1.14 1.185 1.14zm3.129-.06h.4v-.83h.48v-.375h-.48v-2.34h-.34l-1.615 2.305v.41h1.555V20zm-1.19-1.205l1.18-1.735h.01v1.735h-1.19zM13.52 28.536l.52-.768.553.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.612 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.612 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zM46.52 28.536l.52-.768.553.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.612 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.613 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248zm3.612 0l.52-.768.552.768.328-.248-.528-.728.872-.304-.16-.384-.856.32v-.904h-.424v.904l-.848-.32-.144.384.848.304-.52.728.36.248z",
    fill: "#333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.01,
    y: 13.455,
    width: 14.999,
    height: 8.617,
    rx: 1.75,
    stroke: "#C00",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.453,
    y: 11.454,
    width: 9.427,
    height: 6.236,
    rx: 0.802,
    fill: "#1F72CD",
    stroke: "#CED4D9",
    strokeWidth: 0.146
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.096 13.64l-.896 1.928h1.073l.133-.307h.303l.133.307h1.18v-.235l.106.235h.61l.105-.24v.24h2.455l.298-.3.28.3 1.26.002-.898-.96.898-.97h-1.24l-.291.295-.27-.294h-2.671l-.23.497-.234-.497h-1.07v.226l-.119-.226h-.915zm.207.274h.523l.594 1.307v-1.307h.572l.46.937.422-.937h.57v1.383h-.347l-.003-1.083-.505 1.083h-.31l-.508-1.083v1.083h-.713l-.136-.31h-.73l-.135.31h-.382l.628-1.383zm4.868 0h-1.41v1.382h1.388l.447-.458.431.458h.45l-.654-.687.655-.695h-.431l-.445.453-.431-.453zm-4.614.234l-.24.553h.48l-.24-.553zm3.553.305v-.252h.879l.384.403-.401.406h-.863v-.276h.77v-.28h-.77z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.82,
    cy: 26.969,
    r: 4.558,
    fill: "#666"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.573,
    y: 11.573,
    width: 9.427,
    height: 6.236,
    rx: 0.802,
    fill: "#CED4D9",
    stroke: "#CED4D9",
    strokeWidth: 0.146
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.341 16.122a1.878 1.878 0 01-1.21.438c-1.031 0-1.867-.821-1.867-1.835s.836-1.836 1.867-1.836c.462 0 .884.165 1.21.439a1.878 1.878 0 011.21-.439c1.032 0 1.867.822 1.867 1.836 0 1.014-.835 1.835-1.866 1.835-.462 0-.885-.165-1.21-.438z",
    fill: "#CED4D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.341 16.122a1.82 1.82 0 000-2.794 1.878 1.878 0 011.21-.439c1.032 0 1.867.822 1.867 1.836 0 1.014-.835 1.835-1.866 1.835-.462 0-.885-.165-1.21-.438z",
    fill: "#CED4D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.34 16.122a1.82 1.82 0 000-2.794 1.82 1.82 0 000 2.794z",
    fill: "#CED4D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cvvAmex_svg__filter0_dd_1909_22582",
    x: 0.109,
    y: 0.582,
    width: 77.423,
    height: 53.072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.473
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.945
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_22582"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.473
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1909_22582",
    result: "effect2_dropShadow_1909_22582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1909_22582",
    result: "shape"
  })))));
};
export default SvgCvvAmex;